<template>
  <div v-if="currentCamp != null" class="box-body">
    <p class="text-green">{{ $t('camps.camp-item.new-value') }}</p>
    <div class="form-group">
      <label>{{ $t('camps.camp-item.name') }}</label>
      <input type="text" class="form-control" v-model="currentCamp.name[language]"
             placeholder="">
    </div>
    <div class="form-group">
      <label>
        {{ $t('camps.camp-item.link') }}
      </label>
      <input type="text" :disabled="isCabinet()" class="form-control" v-model="currentCamp.urlName">
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditCamp',
  props: {
    currentCamp: {},
    language: String
  },
  methods: {
    isCabinet: function () {
      return window.application === 'cabinet';
    }
  }
};
</script>

<style scoped>

</style>
